import axios from 'axios';
import { ContactPartnerDetailsItemInterface } from '../interfaces/internationalContact';
import { ContactPartnerDetailsExmaple } from '../templateObjects/internationalContact';

export const useFetchPartnerDetails = async (
    countryShortName: string,
    vkg: string
): Promise<ContactPartnerDetailsItemInterface> => {
    const data = await axios.post(
        `${process.env.DRUPAL_URL}/graphql`,
        {
            query: `query fetchPartnerDetails($short_name: String!, $vkg: String!) {
                        partner_details(short_name: $short_name, vkg: $vkg) {
                            data
                        }
                    }
            `,
            variables: {
                short_name: countryShortName,
                vkg: vkg,
            },
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    const result = JSON.parse(data?.data?.data?.partner_details?.data);
    return result ?? ContactPartnerDetailsExmaple;
};
